function loadFirstBrand(cName,sName) {
    $.ajax({
        url: `/collections/${cName}`,
        method: 'GET',
        success: function(responseTxt, statusTxt, jqXHR) {
            if (statusTxt === "success") {
                // console.log('jqXHR',jqXHR);
                // Parse the response to extract the content of the #product-grid div
                // let hasBrand = $(responseTxt).find('ul#product-grid > li:nth-child(-n+10)');

                $('.products-slider-container '+sName+'.collection-list').empty();
                let hasBrand = $(responseTxt).find('ul#product-grid > li:nth-child(-n+10)');


                // Append the products to the container
                $('.products-slider-container .'+sName+'.collection-list').append(hasBrand);

                // Initialize the slick slider
                initializeSlickSlider('new-arrivals');
                initializeSlickSlider('sale');

                // console.log($(document).find('.products-slider-container .new-arrivals.collection-list li.grid__item .swatches li'));
                // $(document).find('.products-slider-container .new-arrivals.collection-list li.grid__item .swatches li').each(function(){
                //     console.log($(this));
                //     $(this).click(function(){
                //         console.log('clicked')
                //     })
                // })
                const fullCard = document.querySelectorAll('.card-wrapper.product-card-wrapper');
                fullCard.forEach((element) => {
                    let swatchItem = element.querySelector('.swatches ul li');
                    if (swatchItem) {
                        let imageData = element.querySelector('.card__inner > .card__media > .media > img')?.getAttribute('srcset');
                        let swatchImageData = element.querySelector('.swatches ul li img').getAttribute('data-color');
                        if (imageData?.includes(swatchImageData)) {
                            swatchItem.classList.add("color-swatch-border");
                        }
                    }
                });
                $('.loader-parent').hide();
                if($('.products-slider-container').has('ul.collection-list')){
                    $('.loader-parent').hide()
                }
                // $(document).find('.products-slider-container .new-arrivals.collection-list li.grid__item .swatches li')
                // const uls = document.querySelectorAll('.products-slider-container .new-arrivals.collection-list li.grid__item .swatches li')
                const uls = document.querySelectorAll('.products-slider-container li.grid__item .swatches li')
                const filteredUls = Array.from(uls).filter(li => !li.querySelector('a'));
                filteredUls.forEach((li, idx) => {
                    // li.addEventListener('click', () => {
                    li.addEventListener('click', function () {
                        $(li).siblings().removeClass('color-swatch-border')
                        li.classList.add('color-swatch-border')
                        // console.log('li', li.getAttribute('data-media'))
                        const clrName = li.querySelector('img').getAttribute('data-color1');
                        var clrNameOriginal = li.querySelector('img').getAttribute('data-color');
                        globalClrNameOriginal = clrNameOriginal;
                        const dataMediaValue = li.getAttribute('data-media');
                        const dataVariantsValue = li.getAttribute('data-variants');
                        // console.log('json media', dataMediaValue);
                        // console.log('json variants', dataVariantsValue);
                        const jsonData = JSON.parse(dataMediaValue);
                        const jsonDataVariants = JSON.parse(dataVariantsValue);
                        // console.log('json media', jsonData);
                        // console.log('json DataVariants', jsonDataVariants);
                        // console.log('li', li.querySelector('img').getAttribute('data-color'))
                        const filteredClrs = jsonData.filter(jd => {
                            return jd.src.includes(clrName)
                        });
                        const filteredvariant = jsonDataVariants.filter(jv => {
                            return jv.option1.includes(clrName)
                        });
                        // console.log('clrNameOriginal', clrNameOriginal);
                        // console.log('jsonDataVariants', jsonDataVariants);
                        // console.log('filteredClrs', filteredClrs);
                        // console.log('filteredvariant', filteredvariant);


                        if (filteredClrs.length === 1) {
                            const img1 = filteredClrs[0].src;
                            li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("srcset", '');
                            li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("src", img1);
                            li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("srcset", '');
                            li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("src", img1);
                            return; // Exit the function since there's only one image
                        }
                        const variant1 = filteredvariant[0].id;
                        const variant2 = filteredvariant[1].id;
                        const img1 = filteredClrs[0].src;
                        const img2 = filteredClrs[1].src;

                        let mediaItem1 = li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)')
                        let mediaItem2 = li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)')
                        let anchorTag = li.closest('li.grid__item').querySelector('.product-link');
                        let currHref = li.closest('li.grid__item').querySelector('.product-link').getAttribute('href');
                        // console.log('a tag', anchorTag);
                        var newHref = currHref.replace(currHref, currHref + '?variant=' + variant1);

                        anchorTag.setAttribute('href', newHref);
                        // mediaItem1.setAttribute("srcset", '');
                        // mediaItem1.setAttribute("src", img1);
                        // mediaItem2.setAttribute("srcset", '');
                        // mediaItem2.setAttribute("src", img2);

                        li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("srcset", '');
                        li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("src", img1);
                        li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("srcset", '');
                        li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("src", img2);
                    })
                })

                //console.log('fffff', $('.products-slider-container .'+sName+'.collection-list'))

                $(document).find('.products-slider-container .'+sName+'.collection-list  li.grid__item').each(function(){

                    //console.log('thisvvvv', $(this));
                    $(this).find('.card-wrapper .card .card__inner').mouseenter(function(){
                        var notAvailableOption2Sizes = [];
                        var notAvailableOption1Sizes = [];
                        //   console.log('this parent', $(this).parents('li.grid__item').data('variants'));
                        //   console.log('swatch length',$(this).parents('li.grid__item').find('.color-swatch-border').length)
                        let colorText = $(this).parents('li.grid__item').find('.color-swatch-border').data('color');
                        let prodVariants = $(this).parents('li.grid__item').find('.color-swatch-border').data('variants')
                        let prodVariantsIfOnlySizes = $(this).parents('li.grid__item').data('variants')
                        if($(this).parents('li.grid__item').find('.color-swatch-border').length > 0){
                            var filteredvariant = prodVariants.filter(jv => {
                                if(colorText){
                                    return jv.option1.includes(colorText)
                                }
                                else{
                                    return jv.option1.includes(sizeText)
                                }
                            });
                            // console.log('fv', filteredvariant);

                            var notAvailableSizes = filteredvariant.filter(fv => {
                                return !fv.available
                            })

                            // console.log('notavilable sizes', notAvailableSizes);

                            notAvailableSizes.forEach(function(item) {
                                notAvailableOption2Sizes.push(item.option2);
                            });
                            // console.log('notAvailableOption2Sizes',notAvailableOption2Sizes)

                            var option2Array = notAvailableSizes.map(function(item) {
                                // return notAvailableOption2Sizes.push(item.option2);
                            });

                            $(this).find("ul.sizes-ul li").each(function(index,element) {
                                var listItem = $(this).find('button');
                                var text = listItem.text().trim();
                                // console.log('index', index);
                                // console.log('element',element);
                                listItem.removeClass("disabled");
                                // If the text matches an item in the array, add the 'disabled' class
                                if (notAvailableOption2Sizes.includes(text)) {
                                    listItem.addClass("disabled");
                                }
                            });
                        }

                        if($(this).parents('li.grid__item').find('.color-swatch-border').length === 0){
                            // console.log('prodVariants', prodVariantsIfOnlySizes)
                            var notAvailableSizesOnly = prodVariantsIfOnlySizes.filter(fv => {
                                return !fv.available
                            })

                            notAvailableSizesOnly.forEach(function(item) {
                                notAvailableOption1Sizes.push(item.option1);
                            });
                            // console.log('notAvailableOption1Sizes',notAvailableOption1Sizes)

                            $(this).find("ul.sizes-ul li").each(function(index,element) {
                                var listItem = $(this).find('button');
                                var text = listItem.text().trim();
                                // console.log('index', index);
                                // console.log('element',element);
                                listItem.removeClass("disabled");
                                // If the text matches an item in the array, add the 'disabled' class
                                if (notAvailableOption1Sizes.includes(text)) {
                                    listItem.addClass("disabled");
                                }
                            });



                        }

                    })
                })


                // Code For Adding product to Cart from PLP select size

                $(document).on("click", '.addToCart', function () {
                    // console.log('this size text', $(this).text());
                    // console.log('this color',$(this).parents('li.grid__item').find('.color-swatch-border').data('color'))
                    // console.log('this variants',$(this).parents('li.grid__item').find('.color-swatch-border').data('variants'))
                    let sizeText = $(this).text();
                    // console.log($(this).parents('li').attr('data-variants'));
                    // console.log('swatch length',$(this).parents('li.grid__item').find('.color-swatch-border').length)
                    let swatchesLength  = $(this).parents('li.grid__item').find('.color-swatch-border').length;
                    let colorText = $(this).parents('li.grid__item').find('.color-swatch-border').data('color');
                    let prodVariants = $(this).parents('li.grid__item').find('.color-swatch-border').data('variants')
                    // console.log('variants',$(this).parents('li').data('variants'));
                    let onlySizeVariants = $(this).parents('.sizes-ul').data('variants');
                    // console.log('onlySizeVariants', onlySizeVariants)
                    //  return;
                    if(swatchesLength > 0){
                        var filteredvariant = prodVariants.filter(jv => {
                            if(colorText && sizeText){
                                return jv.option1.includes(colorText) && jv.option2 == sizeText
                            }
                            else{
                                return jv.option1.includes(sizeText)
                            }
                        });
                    }
                    if(swatchesLength === 0){
                        var filteredvariant = onlySizeVariants.filter(jv => {
                            // console.log('jv',jv.option1)
                            return jv.option1 == sizeText;
                        });
                    }
                    // console.log('result', filteredvariant)
                    // console.log('result variant id', filteredvariant[0]?.id)
                    let selectedVariant = filteredvariant[0]?.id;
                    // return;
                    let t = 1, e = $(this).attr("data-variant-id"), a = {
                        type: "POST", url: "/cart/add.js", data: {quantity: t, id: selectedVariant}, dataType: "json", success: function (i) {
                            // window.location.href.indexOf("wishlist") > -1 && console.log("trigger remove of item from wishlist.")
                            $('cart-drawer').load(location.href + " #CartDrawer");
                            $('cart-drawer').removeClass('is-empty');
                            $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
                            $('.drawer__close').load(location.href + " #cart-icon-bubble");
                            // console.log("Added the product to cart but not showing in cart because it need to reload");
                            document.documentElement.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {quantity: t}
                            }));
                            document.getElementById('cart-icon-bubble').click();
                        }, error: function () {
                            alert("sold out, sorry!")
                        }
                    };
                    $.ajax(a)
                });



            } else {
                console.log("Error: " + jqXHR.status + " " + jqXHR.statusText);
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log("Error: " + jqXHR.status + " " + jqXHR.statusText);
        }
    });
}

function initializeSlickSlider(sName) {
    const $slider = $('.products-slider-container .'+sName+'.collection-list');

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick'); // Destroy the previous instance if it exists
    }

    $slider.slick({
        slidesToShow: 1.4,
        mobileFirst: true,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    arrows: true,
                    infinite: true,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    infinite: true,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}





$(document).ready(function() {
    // On page load, load the first collection
    let firstColl = $('.list-container.new-arrivals span:first-of-type').data('rel');
    let secFirstColl = $('.list-container.sale span:first-of-type').data('rel');
    if(firstColl) {
        loadFirstBrand(firstColl, 'new-arrivals');
    }
    if(secFirstColl) {
        loadFirstBrand(secFirstColl, 'sale');
    }
    // Handle button clicks
    $('.list-container.new-arrivals > span').each(function () {
        $(this).click(function () {
            // console.log('collection title', $(this).data('rel'));
            $('.products-slider-container .new-arrivals.collection-list').slick('unslick');
            $('.products-slider-container .new-arrivals.collection-list').empty();
            let collName = $(this).data('rel');
            $(".loader-parent").show()
            $('.loader').show();
            loadFirstBrand(collName, 'new-arrivals');
        });
    });

    $('.list-container.sale > span').each(function () {
        $(this).click(function () {
            $(this).addClass('active').siblings().removeClass('active')
            // console.log('collection title', $(this).data('rel'));
            $('.products-slider-container .sale.collection-list').slick('unslick');
            $('.products-slider-container .sale.collection-list').empty();
            let collName = $(this).data('rel');
            $(".loader-parent").show()
            $('.loader-2').show();
            loadFirstBrand(collName, 'sale');
            let saleSection = $(".home-collection-tabs.section-bottom-gap.sale")
            let activeCollection = saleSection.find('span.active')
            // let collName = activeCollection.attr('id')
            if(saleSection){
                saleSection.find('.btn-container.sale > a').attr("href", `/collections/${collName}`)
            }
        });
    });
});

$(document).ready(function () {

    // $('.sale .collection-name').click(function(){
    //     $('.sale .collection-name').removeClass("active");
    //     $(this).addClass("active");
    //     return false;
    // });
    // if ($('.sale.home-collection-tabs .sale.collection-list').length) {
    //     // $('.sale.home-collection-tabs .sale.collection-list').slick({
    //     //     //centerMode: true,
    //     //     //centerPadding: '152px',
    //     //     slidesToShow: 1.4,
    //     //     //focusOnSelect: true,
    //     //     mobileFirst: true,
    //     //     arrows: true,
    //     //     infinite: false,
    //     //     responsive: [
    //     //         {
    //     //             breakpoint: 1400,
    //     //             settings: {
    //     //                 arrows: true,
    //     //                 infinite: true,
    //     //                 //centerMode: true,
    //     //                 // centerPadding: '152px',
    //     //                 slidesToShow: 4
    //     //             }
    //     //         },
    //     //         {
    //     //             breakpoint: 1024,
    //     //             settings: {
    //     //                 arrows: true,
    //     //                 infinite: true,
    //     //                 //centerMode: true,
    //     //                 //centerPadding: '152px',
    //     //                 slidesToShow: 4
    //     //             }
    //     //         },
    //     //         {
    //     //             breakpoint: 768,
    //     //             settings: {
    //     //                 arrows: true,
    //     //                 //centerMode: true,
    //     //                 //centerPadding: '152px',
    //     //                 slidesToShow: 2
    //     //             }
    //     //         },
    //     //         {
    //     //             breakpoint: 480,
    //     //             settings: {
    //     //                 arrows: true,
    //     //                 //centerMode: true,
    //     //                 //centerPadding: '40px',
    //     //                 slidesToShow: 1,
    //     //                 slidesToScroll: 1
    //     //             }
    //     //         }
    //     //     ]
    //     // });
    // }
    // let selectedBtn = "";
    // $('.list-container.sale .collection-name').click(function(){
    //     // Remove active class from previously selected button
    //     $('.shop-all-btn.show-btn').removeClass("show-btn");
    //
    //     // Add active class to the clicked button
    //     selectedBtn = $(this).attr('data-rel');
    //     console.log('selectedBtn', selectedBtn);
    //     $('.sale .shop-all-btn.' + selectedBtn).addClass("show-btn");
    //     return false;
    // });
    //
    // $(function() {
    //     // create an empty variable
    //     var selectedClass = "";
    //     $(".sale .collection-name").click(function(){
    //         console.log("section of collection tabs ")
    //         selectedClass = $(this).attr("data-rel");
    //         $('.prod-title').css('opacity', 0);
    //         setTimeout(function(){
    //             $('.sale.home-collection-tabs .sale.collection-list').slick("refresh");
    //             $('.prod-title').css('opacity', 1);
    //         },100);
    //         // fades out all portfolio items
    //         $(".sale.home-collection-tabs .sale.collection-list").fadeOut(10);
    //         $(".sale.home-collection-tabs .sale.collection-list." + selectedClass).removeClass('other-collection');
    //         // fades in selected category
    //         $(".sale.home-collection-tabs .sale.collection-list." + selectedClass).delay(10).fadeIn(10);
    //     });
    // });



//new Arrivals
    $('.new-arrivals .collection-name').click(function(){
        $('.new-arrivals .collection-name').removeClass("active");
        $(this).addClass("active");

        let newASection = $(".home-collection-tabs.section-bottom-gap.new-arrivals")
        let newActiveCollection = newASection.find('span.active')
        let newCollName = newActiveCollection.attr('id')
        if(newASection){
            newASection.find('.btn-container.new-arrivals > a').attr("href", `/collections/${newCollName}`)
        }
        return false;
    });
    if($('.new-arrivals.home-collection-tabs .new-arrivals.collection-list').length){
        // $('.new-arrivals.home-collection-tabs .new-arrivals.collection-list').slick({
        //     //centerMode: true,
        //     //centerPadding: '152px',
        //     slidesToShow: 1.4,
        //     //focusOnSelect: true,
        //     mobileFirst: true,
        //     arrows: true,
        //     infinite: false,
        //     responsive: [
        //         {
        //             breakpoint: 1400,
        //             settings: {
        //                 arrows: true,
        //                 infinite: true,
        //                 //centerMode: true,
        //                 // centerPadding: '152px',
        //                 slidesToShow: 4
        //             }
        //         },
        //         {
        //             breakpoint: 1024,
        //             settings: {
        //                 arrows: true,
        //                 infinite: true,
        //                 //centerMode: true,
        //                 //centerPadding: '152px',
        //                 slidesToShow: 4
        //             }
        //         },
        //         {
        //             breakpoint: 768,
        //             settings: {
        //                 arrows: true,
        //                 //centerMode: true,
        //                 //centerPadding: '152px',
        //                 slidesToShow: 2
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 arrows: true,
        //                 //centerMode: true,
        //                 //centerPadding: '40px',
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         }
        //     ]
        // });
    }
    let selectedBtnNew = "";
    $('.list-container.new-arrivals .collection-name').click(function(){
        // Remove active class from previously selected button
        $('.shop-all-btn.show-btn').removeClass("show-btn");

        // Add active class to the clicked button
        selectedBtnNew = $(this).attr('data-rel');
        // console.log('selectedBtn', selectedBtnNew);
        $('.new-arrivals .shop-all-btn.' + selectedBtnNew).addClass("show-btn");
        return false;
    });
    /*
        // $(function() {
        //     // create an empty variable
        //     var selectedClass = "";
        //     // $(".new-arrivals .collection-name").click(function(){
        //     //     console.log("section of collection tabs ")
        //     //     selectedClass = $(this).attr("data-rel");
        //     //     $('.prod-title').css('opacity', 0);
        //     //     setTimeout(function(){
        //     //         $('.new-arrivals.home-collection-tabs .new-arrivals.collection-list').slick("refresh");
        //     //         $('.prod-title').css('opacity', 1);
        //     //     },100);
        //     //     // fades out all portfolio items
        //     //     $(".new-arrivals.home-collection-tabs .new-arrivals.collection-list").fadeOut(10);
        //     //     $(".new-arrivals.home-collection-tabs .new-arrivals.collection-list." + selectedClass).removeClass('other-collection');
        //     //     // fades in selected category
        //     //     $(".new-arrivals.home-collection-tabs .new-arrivals.collection-list." + selectedClass).delay(10).fadeIn(10);
        //     // });
        // });

        let firstColl =  $('.list-container.new-arrivals span:first-of-type').data('rel')
        loadFirstBrand(firstColl);

        $('.list-container.new-arrivals > span').each(function(){
            $(this).click(function(){
                console.log('collection title', $(this).data('rel'))
                $('.products-slider-container  .new-arrivals.collection-list').empty();
                let collName = $(this).data('rel');
                loadFirstBrand(collName);


            })
        })

        let collFound = setInterval(function(){
            if($('.products-slider-container  .new-arrivals.collection-list li').length > 0){

                $('.products-slider-container  .new-arrivals.collection-list').slick({
                    //centerMode: true,
                    //centerPadding: '152px',
                    slidesToShow: 1.4,
                    //focusOnSelect: true,
                    mobileFirst: true,
                    arrows: true,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                arrows: true,
                                infinite: true,
                                //centerMode: true,
                                // centerPadding: '152px',
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                arrows: true,
                                infinite: true,
                                //centerMode: true,
                                //centerPadding: '152px',
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: true,
                                //centerMode: true,
                                //centerPadding: '152px',
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                arrows: true,
                                //centerMode: true,
                                //centerPadding: '40px',
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });

                clearInterval(collFound);
            }
            else{

            }
        },200);





        function loadFirstBrand(cName) {
            $.ajax({
                url: `/collections/${cName}`,
                method: 'GET',
                success: function(responseTxt, statusTxt, jqXHR) {
                    if (statusTxt === "success") {
                        // Parse the response to extract the content of the #product-grid div
                        let hasBrand = $(responseTxt).find('ul#product-grid > li:nth-child(-n+10)');

                        $('.products-slider-container  .new-arrivals.collection-list').append(hasBrand);


                        console.log('response text', hasBrand);

                    } else {
                        alert("Error: " + jqXHR.status + " " + jqXHR.statusText);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    alert("Error: " + jqXHR.status + " " + jqXHR.statusText);
                }
            });
        }

    */


    function initializeSlick() {
        $('#ProductGridContainer ul#product-grid > li .card .card__media .media').each(function () {
            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768, // Mobile breakpoint
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 1024, // Tablet breakpoint
                            settings: 'unslick'
                        },
                        {
                            breakpoint: 1200, // Desktop breakpoint
                            settings: 'unslick'
                        }
                    ]
                });
            }
        });
    }

    function updateDotsView(view) {
        const productGrid = $('.product-grid');

        if (view === 'two') {
            productGrid.addClass('product-grid-four-dots');
            initializeSlick();
        } else {
            productGrid.removeClass('product-grid-four-dots');
            initializeSlick()
        }

        $('.two-dots').css("opacity", view === 'two' ? "1" : "0.5");
        $('.four-dots').css("opacity", view === 'four' ? "1" : "0.5");
    }

    function unslickAll() {
        $('#ProductGridContainer ul#product-grid > li .card .card__media .media').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        });
    }

    $(document).ready(function() {

        // $('.two-dots').css("opacity", "0.5");

        $('.grid-filter .product-list-change-filter .two-dots, .mobile-product-grid-filter .product-list-change-filter .two-dots').click(function () {
            unslickAll();
            updateDotsView('two');
        });

        $('.grid-filter .product-list-change-filter .four-dots, .mobile-product-grid-filter .product-list-change-filter .four-dots').click(function () {
            unslickAll();
            updateDotsView('four');
        });
        // setTimeout(() => {
        //     if(!$(".collection-page .card__media .slick-dots > li:nth-of-type(2)").length){
        //         $(".card__media .slick-dots").hide()
        //     }
        // }, 2000)
    });
    // console.log('on load length',$('.prod-images .product__media-list > li[data-alt='+ $('.custom-color-swatches input[checked]').val()+']').length);
    var color = $('.custom-color-swatches input[checked]').val();

    if ($('.prod-images .product__media-list > li[data-alt="' + color + '"]').length > 0) {
        $('.prod-images .product__media-list > li[data-alt="' + color + '"]').css('display', 'block');
    } else {
        $('.prod-images .product__media-list > li').css('display', 'block');
    }

    $('.custom-color-swatches input').on('change', function() {
        var color = $.escapeSelector($(this).val());
        $('.prod-images .product__media-list > li[data-alt]').css('display', 'none');
        var $matchedElement = $('.prod-images .product__media-list > li[data-alt="' + color + '"]');
        if ($matchedElement.length > 0) {
            $matchedElement.css('display', 'block');
        } else {
            $('.prod-images .product__media-list > li').css('display', 'block');
        }
    });




    var uls = document.querySelectorAll('.swatches ul li');
    let globalClrNameOriginal;
    let newArrivals = document.querySelectorAll('.new-arrivals .swatches ul li');
    const filteredUls = Array.from(uls).filter(li => !li.querySelector('a'));

    filteredUls.forEach((li, idx) => {
        // li.addEventListener('click', () => {
        li.addEventListener('click', function () {

           // $('#ProductGridContainer ul#product-grid > li').each(function () {
           //      $(this).parents('li.grid__item').find('.card .card__media .media').slick('unslick');
          //  })
            $(li).siblings().removeClass('color-swatch-border')
            li.classList.add('color-swatch-border')
            // console.log('li', li.getAttribute('data-media'))
            const clrName = li.querySelector('img').getAttribute('data-color1').toLowerCase();
            var clrNameOriginal = li.querySelector('img').getAttribute('data-color');
            globalClrNameOriginal = clrNameOriginal;
            const dataMediaValue = li.getAttribute('data-media');
            const dataVariantsValue = li.getAttribute('data-variants');
            // console.log('json media', dataMediaValue);
            // console.log('json variants', dataVariantsValue);
            const jsonData = JSON.parse(dataMediaValue);
            const jsonDataVariants = JSON.parse(dataVariantsValue);
            // console.log('json media', jsonData);
            // console.log('json DataVariants', jsonDataVariants);
            // console.log('li', li.querySelector('img').getAttribute('data-color'))
            const filteredClrs = jsonData.filter(jd => {
                let loweredVariant = jd.src.toLowerCase()
                // console.log(loweredVariant, ' IMG SRC')
                return loweredVariant.includes(clrName)
            });
            const filteredvariant = jsonDataVariants.filter(jv => {
                return jv.option1.includes(clrNameOriginal)
            });
            // console.log('clrNameOriginal', clrNameOriginal);
            // console.log('jsonDataVariants', jsonDataVariants);
            // console.log('filteredClrs', filteredClrs);
            // console.log('filteredvariant', filteredvariant);


            if (filteredClrs.length === 1) {
                const img1 = filteredClrs[0].src;
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("srcset", '');
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("src", img1);
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("srcset", '');
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("src", img1);
                $(this).parents('li.grid__item').find('.card .card__media .media').slick('unslick');
                return; // Exit the function since there's only one image
            }

            const variant1 = filteredvariant[0].id;
            // const variant2 = filteredvariant[1].id;


            let mediaItem1 = li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)')
            let mediaItem2 = li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)')
            let anchorTag = li.closest('li.grid__item').querySelector('.product-link');
            let currHref = li.closest('li.grid__item').querySelector('.product-link').getAttribute('href');
            // console.log('a tag', anchorTag);
            var newHref = currHref.replace(currHref, currHref + '?variant=' + variant1);

            anchorTag.setAttribute('href', newHref);
            // mediaItem1.setAttribute("srcset", '');
            // mediaItem1.setAttribute("src", img1);
            // mediaItem2.setAttribute("srcset", '');
            // mediaItem2.setAttribute("src", img2);
            if (filteredClrs.length > 1){
                const img1 = filteredClrs[0].src;
                const img2 = filteredClrs[1].src;
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("srcset", '');
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(1)').setAttribute("src", img1);
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("srcset", '');
                li.closest('li.grid__item').querySelector('.card__media .media img:nth-of-type(2)').setAttribute("src", img2);
            // initializeSlickSliderMobilePLP();
                $(this).parents('li.grid__item').find('.card .card__media .media').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768, // Mobile breakpoint
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 1024, // Tablet breakpoint
                            settings: 'unslick'
                        },
                        {
                            breakpoint: 1200, // Desktop breakpoint
                            settings: 'unslick'
                        }
                    ]
                });
            }


            // console.log('testing')
        })
    })
    // console.log('globalClrNameOriginal',globalClrNameOriginal)

    const fullCard = document.querySelectorAll('.card-wrapper.product-card-wrapper');
    fullCard.forEach((element) => {
        let swatchItem = element.querySelector('.swatches ul li');
        if (swatchItem) {
            let imageData = element.querySelector('.card__inner > .card__media > .media  img').getAttribute('srcset').toLowerCase();
            let swatchImageData = element.querySelector('.swatches ul li img').getAttribute('data-color1');
            if (imageData.includes(swatchImageData)) {
                swatchItem.classList.add("color-swatch-border");
            }
        }
    });


    $('ul.product-description-tabs > li').click(function(e){
        var tab_id = $(this).attr('data-tab');

        $(this).parent().find('li').removeClass('current');
        $('.shopify-tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    })



// Code For Adding product to Cart from PLP select size

    $(document).on("click", '.addToCart', function () {
        // console.log('this size text', $(this).text());
        // console.log('this color',$(this).parents('li.grid__item').find('.color-swatch-border').data('color'))
        // console.log('this variants',$(this).parents('li.grid__item').find('.color-swatch-border').data('variants'))
        let sizeText = $(this).text();
        // console.log($(this).parents('li').attr('data-variants'));
        // console.log('swatch length',$(this).parents('li.grid__item').find('.color-swatch-border').length)
        let swatchesLength  = $(this).parents('li.grid__item').find('.color-swatch-border').length;
        let colorText = $(this).parents('li.grid__item').find('.color-swatch-border').data('color');
        let prodVariants = $(this).parents('li.grid__item').find('.color-swatch-border').data('variants')
        // console.log('variants',$(this).parents('li').data('variants'));
        let onlySizeVariants = $(this).parents('.sizes-ul').data('variants');
        // console.log('onlySizeVariants', onlySizeVariants)
      //  return;
        if(swatchesLength > 0){
        var filteredvariant = prodVariants.filter(jv => {
            if(colorText && sizeText){
            return jv.option1.includes(colorText) && jv.option2 == sizeText
            }
            else{
                return jv.option1.includes(sizeText)
            }
        });
        }
        if (swatchesLength === 0) {
            var filteredvariant = onlySizeVariants.filter(jv => {
                if (jv.option1 === sizeText) {
                    return true;
                } else if (jv.option2 === sizeText) {
                    return true;
                }
                return false;
            });
        }
        // console.log('result', filteredvariant)
        // console.log('result variant id', filteredvariant[0].id)
        let selectedVariant = filteredvariant[0].id;
        // return;
    let t = 1, e = $(this).attr("data-variant-id"), a = {
        type: "POST", url: "/cart/add.js", data: {quantity: t, id: selectedVariant}, dataType: "json", success: function (i) {
            // window.location.href.indexOf("wishlist") > -1 && console.log("trigger remove of item from wishlist.")
            $('cart-drawer').load(location.href + " #CartDrawer");
            $('cart-drawer').removeClass('is-empty');
            $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
            $('.drawer__close').load(location.href + " #cart-icon-bubble");
            // console.log("Added the product to cart but not showing in cart because it need to reload");
            document.documentElement.dispatchEvent(new CustomEvent("product:added", {
                bubbles: !0,
                detail: {quantity: t}
            }));
            document.getElementById('cart-icon-bubble').click();
        }, error: function () {
            alert("sold out, sorry!")
        }
    };
    $.ajax(a)
});

// end of the select size

    $('.rendering-breadcrumbs').append($('.custom-breadcrumbs'))
    $('#tab-reviews').append($('#shopify-block-reviews_io_reviewsio_polaris_8thNpa'));

    setTimeout(() => {
        if($('product-recommendations .product-grid .grid__item').length >= 5) {
            $('product-recommendations .product-grid').slick({
                slidesToShow: 4.5,
                slidesToScroll: 1,
                autoplay: false,
                arrow: true,
                infinite: false,
            });
        }
    }, 2000)

let pdpTotalMediaCout = $('.pdp-mobile-slider-count').data('count');
  //  console.log('mediaCount', pdpTotalMediaCout);
    $('.pdp-mobile-slider-count').find('.slider-counter--total').empty();
    setTimeout(function(){
        $('.pdp-mobile-slider-count').find('.slider-counter--total').text(pdpTotalMediaCout);
    },1000)
if($(window).width() < 768){
    if($('.slider-bars').length > 1){
    let foundCurrent = setInterval(function(){
        $(document).find('.slider-bars .slider-bar').removeClass('active-slide')
       // console.log($(document).find('.slider-bars .slider-counter--current').text());
        let currentSlide = $(document).find('.slider-bars .slider-counter--current').text();
        $(document).find('.slider-bars .slider-bar:nth-child('+currentSlide+')').addClass('active-slide')

    },800)
    }
}
});

// // Mini-cart closing when clicked outside
// let parentMiniCart = document.querySelector('.drawer:has(#CartDrawer)');
// let miniCart = document.querySelector('#CartDrawer');
//
// parentMiniCart.addEventListener('click', function (e) {
//     e.stopPropagation();
//     if (this.classList.contains('active') && !miniCart.contains(e.target)) {
//         parentMiniCart.classList.remove('active');
//         console.log('Closes cart');
//     }
// });
//
// miniCart.addEventListener('click', function (e) {
//     e.stopPropagation();
// });
let announcementBar = document.querySelector('.announcement-bar-section')
let aBHeight = announcementBar.offsetHeight;
if(window.innerWidth < 769 && window.innerWidth > 380){
    let announcementBar = document.querySelector('.announcement-bar-section')
    let aBHeight = announcementBar.offsetHeight;
    let cartDrawer = document.querySelector('cart-drawer.drawer')
    let cartInner = cartDrawer.querySelector('.drawer__inner')
    cartDrawer.style.top = `${aBHeight}px`
    cartInner.style.height = `calc(100vh - ${aBHeight}px)`

    function updateCartDrawer() {
        let scrollPosition = window.scrollY;
        let cartTop = 39 - scrollPosition;

        if (scrollPosition > 39) {
            cartDrawer.style.top = '0';
            cartInner.style.height = 'calc(100vh)';
        } else {
            cartDrawer.style.top = `${cartTop}px`;
            cartInner.style.height = `calc(100vh - ${39 - scrollPosition}px)`;
        }
    }
    updateCartDrawer()
    window.addEventListener('scroll',updateCartDrawer)
    let announcementRemove = document.querySelector('.announcement-bar-remove-icon')
    announcementRemove.addEventListener('click', function (){
        cartDrawer.style.top = `0`
        cartInner.style.height = `calc(100vh)`
    })
} else if(window.innerWidth < 380){
    let cartDrawer = document.querySelector('cart-drawer.drawer')
    let cartInner = cartDrawer.querySelector('.drawer__inner')
    cartDrawer.style.top = `${aBHeight}px`
    cartInner.style.height = `calc(100vh - ${aBHeight}px)`

    function updateCartDrawer() {
        let scrollPosition = window.scrollY;
        let cartTop = 57 - scrollPosition;

        if (scrollPosition > 57) {
            cartDrawer.style.top = '0';
            cartInner.style.height = 'calc(100vh)';
        } else {
            cartDrawer.style.top = `${cartTop}px`;
            cartInner.style.height = `calc(100vh - ${57 - scrollPosition}px)`;
        }
    }
    updateCartDrawer()
    window.addEventListener('scroll',updateCartDrawer)
    let announcementRemove = document.querySelector('.announcement-bar-remove-icon')
    announcementRemove.addEventListener('click', function (){
        cartDrawer.style.top = `0`
        cartInner.style.height = `calc(100vh)`
    })
}
if (window.innerWidth > 990) {
    let cartDrawer = document.querySelector('cart-drawer.drawer');
    let cartInner = cartDrawer.querySelector('.drawer__inner');

    function updateCartDrawer() {
        let scrollPosition = window.scrollY;
        let cartTop = 123 - scrollPosition;

        if (scrollPosition > 45) {
            cartDrawer.style.top = '80px';
            cartInner.style.height = 'calc(100vh - 80px)';
        } else {
            cartDrawer.style.top = `${cartTop}px`;
            cartInner.style.height = `calc(100vh - ${123 - scrollPosition}px)`;
        }
    }

    // Update on initial load
    updateCartDrawer();

    // Update on scroll
    window.addEventListener('scroll', updateCartDrawer);
}
 else if(window.innerWidth > 767 && window.innerWidth < 801){
    let cartDrawer = document.querySelector('cart-drawer.drawer')
    let cartInner = cartDrawer.querySelector('.drawer__inner')

    function updateCartDrawer() {
        let scrollPosition = window.scrollY;
        let cartTop = 99 - scrollPosition;

        if (scrollPosition > 45) {
            cartDrawer.style.top = '61px';
            cartInner.style.height = 'calc(100vh - 61px)';
        } else {
            cartDrawer.style.top = `${cartTop}px`;
            cartInner.style.height = `calc(100vh - ${99 - scrollPosition}px)`;
        }
    }
    updateCartDrawer()
    window.addEventListener('scroll', updateCartDrawer)
} else if(window.innerWidth > 800 && window.innerWidth < 991){
    let cartDrawer = document.querySelector('cart-drawer.drawer')
    let cartInner = cartDrawer.querySelector('.drawer__inner')

    function updateCartDrawer() {
        let scrollPosition = window.scrollY;
        let cartTop = 96 - scrollPosition;

        if (scrollPosition > 45) {
            cartDrawer.style.top = '54px';
            cartInner.style.height = 'calc(100vh - 54px)';
        } else {
            cartDrawer.style.top = `${cartTop}px`;
            cartInner.style.height = `calc(100vh - ${96 - scrollPosition}px)`;
        }
    }
    updateCartDrawer();
    window.addEventListener('scroll', updateCartDrawer)
}

 // In Mobile, Clicking on Image redirect to PDP
if(window.innerWidth < 768){
 let IsInCardProduct = document.querySelectorAll('.product-card-wrapper');
 IsInCardProduct.forEach((card) => {
     let cardImage = card.querySelector('.card__inner');
     let cardName = card.querySelector('.card__content .card__heading a.product-link');
     cardImage.addEventListener('click', (e) => {
         cardName.click();
     })
 })
}

// Filters to persist when sorting applied
if (document.querySelector('#SortBy')) {
    document.querySelector('#SortBy').addEventListener('change', function (evt) {
        let url = new URL(window.location.href)
        let sortBy = evt.target.value
        url.searchParams.set('sort_by', sortBy)

        // const filters = document.querySelectorAll('.mobile-facets__item input:checked')
        // filters.forEach(filter => {
        //     console.log(`Adding filter: ${filter.name}=${filter.value}`);
        //     url.searchParams.set(filter.name, filter.value)
        // })
        // console.log(`Redirecting to: ${url.href}`);
        setTimeout(() => {
            window.location.href = url.href;
        }, 500)
    })
}
// window.addEventListener('load', function (){
//     const url = new URL(window.location.href);
//     const filters = document.querySelectorAll('.mobile-facets__item input');
//
//     filters.forEach(filter => {
//         const paramValue = url.searchParams.get(filter.name)
//         if(paramValue && paramValue === filter.value){
//             console.log(`Setting filter checked: ${filter.name}=${filter.value}`);
//             filter.checked = true
//         }
//     })
// })


document.querySelectorAll(".shop-by-category-explore").forEach((item) => {
    let shopByCategoryLink = item.previousElementSibling.querySelector('a[href]');

    if (shopByCategoryLink) {
        let linkText = shopByCategoryLink.href.split("/").pop().split("-");
        let finalText = linkText.map(word => word.toUpperCase()).join(' ');

        item.textContent = finalText;
        item.style.zIndex = '1';

        if (window.innerWidth > 768) {
            item.addEventListener('mouseenter', () => {
                item.textContent = 'EXPLORE';
            });

            item.addEventListener('mouseleave', () => {
                item.textContent = finalText;
            });
        }

        item.addEventListener('click', () => {
            shopByCategoryLink.click();
        });
    }
});

